module.exports = __webpack_public_path__ + "static/banner-moc-1-1-dc4daaf37b2cb9be331ca81fb9cfc8d5.png";